import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import FreelancerAgencyUserTypesEnum from '../Enums/FreelancerAgencyUserTypesEnum';
import booleanHelper from '../Helpers/booleanHelper';
import dateTimeHelper from '../Helpers/datetimeHelper';
import JsxHelper from '../Helpers/JsxHelper';
import FreelancerFeeAdmin from '../Contents/FreelancerInvoicing/FreelancerFees/FreelancerFeeAdmin';
import FreelancerFeeSearchParams from '../Contents/FreelancerInvoicing/FreelancerFees/FreelancerFeeSearchParams';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import Comments from '../Elements/Comments';
import LogComponent from '../Elements/LogComponent';
import FreelancerLineItemAdmin from '../Contents/FreelancerInvoicing/FreelancerLineItem/FreelancerLineItemAdmin';
import FreelancerLineItemSearchParams from '../Contents/FreelancerInvoicing/FreelancerLineItem/FreelancerLineItemSearchParams';
import FreelancerInvoiceAdmin from '../Contents/FreelancerInvoicing/FreelancerInvoices/FreelancerInvoiceAdmin';
import FpaAdmin from '../Contents/FreelancerInvoicing/FreelancerPayableAssignments/FpaAdmin';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import FigmaBadge from '../Elements/FigmaBadge';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FreelancerUserIgnoredSurveyAdmin from '../Contents/FreelancerInvoicing/FreelancerUserIgnoredSurvey/FreelancerUserIgnoredSurveyAdmin';
import DepartmentEnum from '../Enums/DepartmentEnum';
import FreelancerActiveStatusEnum from '../Enums/FreelancerActiveStatusEnum';
import FreelancerUserManagerAdmin from '../Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserManagerAdmin';

export default class FreelancerUserItem {
  constructor(item) {
    if (item === undefined) {
      this.FreelancerUserId = '';
      this.CompanyName = '';
      this.FirstName = '';
      this.LastName = '';
      this.Email = '';
      this.PhoneNumber = '';
      this.LastLoginDate = '';
      this.IsFieldworkPartner = false;
      this.UserType = FreelancerAgencyUserTypesEnum.IndependentUser;
      this.PrimaryFreelancerUserId = 0;
      this.OfficeId = 0;
      this.PaymentOfficeId = 0;
      this.ApolloMgrId1 = '';
      this.ApolloMgrId2 = '';
      this.ApolloMgrId1Orgin = '';
      this.ApolloMgrId2Orgin = '';
      this.ApolloMgrId1Status = true;
      this.ApolloMgrId2Status = true;
      this.IsActive = '';
      this.CreatedDate = dateTimeHelper.toYYYYsMMsDD(new Date());
      this.ModifiedDate = dateTimeHelper.toYYYYsMMsDD(new Date());
      this.ContractExpiryDate = dateTimeHelper.toYYYYsMMsDD(new Date());
      this.IsKAM = false;
      this.IsRM = false;
      this.IsDQ = false;
      this.NumberOfFees = 0;
      this.NumberOfLineItems = 0;
      this.NumberOfInvoices = 0;
      this.NumberOfCreatedInvoices = 0;
      this.NumberOfPayableAssignments = 0;
      this.PrimaryFreelancerUserName = '';
      this.CurrencyCode = '';
      this.CurrencyId = '';
      this.PaymentCurrencyId = '';
      this.PaymentMethod = '';
      this.PaymentInformation = '';
      this.PIAlipayAccount = '';
      this.PIAccountHolderName = '';
      this.PIBankName = '';
      this.PIBranchNameOrId = '';
      this.PIBankAddress = '';
      this.PIBankAccountNumber = '';
      this.PIBankAccountType = '';
      this.PISwiftIFSCCode = '';
      this.PIIBANCodeBankAccountNumber = '';
      this.PIPaypalWiseWesternUnionEmail = '';
      this.PIPIX = '';
      this.PICPFRUT = '';
      this.PIWesternUnionAddress = '';
      this.PIPIS = '';
      this.PIPayNow = '';
      this.PIEvaluatorSassieId = '';
      this.PitpEvaluatorId = '';
      this.EvaluatorEmail = '';
      this.EvaluatorName = '';
      this.EvaluatorWarning = '';
      this.EvaluatorNotFound = false;
      this.TimebasedSettlementEnabled = '';
      this.IsEmployee = false;
      this.InvoiceNeeded = true;
      this.PIWiseTransferMethod = '';
      this.PIWiseTargetCurrencyId = '';
      this.PIWiseTargetCurrencyCode = '';
      this.PIBankCode = '';

      this.DqsupervisorUserName = '';
      this.KamsuperVisorUserName = '';
      this.RmsuperVisorUserName = '';
      this.OfficeName = '';
      this.ContractorLocationCountryId = '';
      this.ContractorLocationCountryName = '';
      this.PIBankNameAndCode = '';
      this.PIPanNo = '';
      this.BareContactUserId = '';
      this.FreelancerRoleIds = [];
      this.PayIfSame = false;
      this.Pimxclabe = null;
      this.TipaltiId = null;
      return;
    }
    this.FreelancerUserId = item.freelancerUserId;
    this.CompanyName = item.companyName;
    this.FirstName = item.firstName;
    this.LastName = item.lastName;
    this.Email = item.email;
    this.PhoneNumber = item.phoneNumber;
    this.LastLoginDate = item.lastLoginDate;
    this.IsFieldworkPartner = item.isFieldworkPartner;
    this.UserType = item.userType;
    this.PrimaryFreelancerUserId = item.primaryFreelancerUserId;
    this.OfficeId = item.officeId;
    this.PaymentOfficeId = item.paymentOfficeId;
    this.PaymentOfficeIdOrgin = null;
    this.PaymentOfficeIdStatus = !!item.paymentOfficeId;
    this.ApolloMgrId1 = parseInt(item.apolloMgrId1) > 0 ? item.apolloMgrId1 : null;
    this.ApolloMgrId2 = parseInt(item.apolloMgrId2) > 0 ? item.apolloMgrId2 : null;
    this.ApolloMgrId1Orgin = '';
    this.ApolloMgrId2Orgin = '';
    this.ApolloMgrId1Status = !!item.apolloMgrId1;
    this.ApolloMgrId2Status = !!item.apolloMgrId2;
    this.IsActive = item.isActive;
    this.CreatedDate = item.createdDate;
    this.ModifiedDate = item.modifiedDate;
    this.ContractExpiryDate = item.contractExpiryDate;
    this.NumberOfFees = item.numberOfFees;
    this.NumberOfLineItems = item.numberOfLineItems;
    this.NumberOfInvoices = item.numberOfInvoices;
    this.NumberOfCreatedInvoices = item.numberOfCreatedInvoices;
    this.NumberOfPayableAssignments = item.numberOfPayableAssignments;
    this.PrimaryFreelancerUserName = item.primaryFreelancerUserName;
    this.CurrencyCode = item.currencyCode;
    this.CurrencyId = item.currencyId;
    this.PaymentCurrencyId = item.paymentCurrencyId;
    this.PaymentCurrencyCode = item.paymentCurrencyCode;
    this.PaymentMethod = item.paymentMethod;
    this.PIWiseTransferMethod = item.piWiseTransferMethod;
    this.PIWiseTargetCurrencyId = item.piWiseTargetCurrencyId;
    this.PIWiseTargetCurrencyCode = item.piWiseTargetCurrencyCode;

    this.PIAlipayAccount = FreelancerUserItem.ifNullThenEmptyString(item.piAlipayAccount);
    this.PIAccountHolderName = FreelancerUserItem.ifNullThenEmptyString(item.piAccountHolderName);
    this.PIBankName = FreelancerUserItem.ifNullThenEmptyString(item.piBankName);
    this.PIBranchNameOrId = FreelancerUserItem.ifNullThenEmptyString(item.piBranchNameOrId);
    this.PIBankAddress = FreelancerUserItem.ifNullThenEmptyString(item.piBankAddress);
    this.PIBankAccountNumber = FreelancerUserItem.ifNullThenEmptyString(item.piBankAccountNumber);
    this.PIBankAccountType = FreelancerUserItem.ifNullThenEmptyString(item.piBankAccountType);
    this.PISwiftIFSCCode = FreelancerUserItem.ifNullThenEmptyString(item.piSwiftIFSCCode);
    this.PIIBANCodeBankAccountNumber = FreelancerUserItem.ifNullThenEmptyString(item.piibanCodeBankAccountNumber);
    this.PIPaypalWiseWesternUnionEmail = FreelancerUserItem.ifNullThenEmptyString(item.piPaypalWiseWesternUnionEmail);
    this.PIPIX = FreelancerUserItem.ifNullThenEmptyString(item.pipix);
    this.PICPFRUT = FreelancerUserItem.ifNullThenEmptyString(item.picpfrut);
    this.PIWesternUnionAddress = FreelancerUserItem.ifNullThenEmptyString(item.piWesternUnionAddress);
    this.PIPIS = FreelancerUserItem.ifNullThenEmptyString(item.pipis);
    this.PIPayNow = FreelancerUserItem.ifNullThenEmptyString(item.piPayNow);
    this.PIEvaluatorSassieId = FreelancerUserItem.ifNullThenEmptyString(item.piEvaluatorSassieId);
    this.OriginalEvaluatorSassieId = FreelancerUserItem.ifNullThenEmptyString(item.piEvaluatorSassieId);
    this.PitpEvaluatorId = FreelancerUserItem.ifNullThenEmptyString(item.pitpEvaluatorId);
    this.EvaluatorEmail = FreelancerUserItem.ifNullThenEmptyString(item.evaluatorEmail);
    this.EvaluatorName = FreelancerUserItem.ifNullThenEmptyString(item.evaluatorName);
    this.EvaluatorWarning = '';
    this.EvaluatorNotFound = false;
    this.OriginalIsActive = item.isActive;
    this.TimebasedSettlementEnabled = FreelancerUserItem.ifNullThenEmptyString(item.timebasedSettlementEnabled);
    this.IsEmployee = item.isEmployee;
    this.InvoiceNeeded = item.invoiceNeeded;
    this.PIBankCode = item.piBankCode;
    this.PIBankNameAndCode = item.piBankNameAndCode;
    this.PIPanNo = item.piPanNo;
    this.BareContactUserId = item.bareContactUserId;
    this.BareContactUserName = item.bareContactUserName;

    this.DqsupervisorUserName = 'Later'; //item.dqsupervisorUserName;
    this.KamsuperVisorUserName = 'Later'; //item.kamsuperVisorUserName;
    this.RmsuperVisorUserName = 'Later'; //item.rmsuperVisorUserName;
    this.OfficeName = item.officeName;
    this.PaymentOfficeName = item.paymentOfficeName;
    this.ContractorLocationCountryId = item.contractorLocationCountryId;
    this.ContractorLocationCountryName = item.contractorLocationCountryName;
    this.RmFreelancerUserManagers = item.rmFreelancerUserManagers ? item.rmFreelancerUserManagers : [];
    this.DqFreelancerUserManagers = item.dqFreelancerUserManagers ? item.dqFreelancerUserManagers : [];
    this.FreelancerRoleIds = item.freelancerRoleIds ? item.freelancerRoleIds : [];
    this.IsKAM = this.FreelancerRoleIds.includes(DepartmentEnum.KAM);
    this.IsRM = this.FreelancerRoleIds.includes(DepartmentEnum.RM);
    this.IsDQ = this.FreelancerRoleIds.includes(DepartmentEnum.DQ);
    this.IsBD = this.FreelancerRoleIds.includes(DepartmentEnum.BD);
    this.IsMarketing = this.FreelancerRoleIds.includes(DepartmentEnum.Marketing);
    this.IsHR = this.FreelancerRoleIds.includes(DepartmentEnum.HR);
    this.IsIT = this.FreelancerRoleIds.includes(DepartmentEnum.IT);
    this.IsFinance = this.FreelancerRoleIds.includes(DepartmentEnum.Finance);
    this.IsBI = this.FreelancerRoleIds.includes(DepartmentEnum.BI);
    this.PayIfSame = item.payIfSame;
    this.IsOffboarded = item.isOffboarded;
    this.ActiveStatus = item.isActive
      ? FreelancerActiveStatusEnum.ActiveEngaged
      : item.isOffboarded
      ? FreelancerActiveStatusEnum.InactiveOffboarded
      : FreelancerActiveStatusEnum.InactiveNotEngaged;
    this.Pimxclabe = item.pimxclabe;
    this.TipaltiId = item.tipaltiId;
  }

  static ifNullThenEmptyString(val) {
    return val ? val : '';
  }

  static NameOfTheIdField() {
    return 'FreelancerUserId';
  }
  static nameOfTheItemDetailList() {
    return 'Vendor';
  }

  static MoneyFields = ['Fee'];

  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static DateFields = ['LastLoginDate', 'ContractExpiryDate', 'CreatedDate', 'ModifiedDate'];

  static BoolFields = [
    'IsFieldworkPartner',
    'IsActive',
    'IsKAM',
    'IsRM',
    'IsDQ',
    'IsBD',
    'IsMarketing',
    'IsHR',
    'IsIT',
    'IsFinance',
    'IsBI',
    'PayIfSame',
  ];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'FreelancerUserId', label: 'Id' },
        { name: (item) => `${item.FirstName} ${item.LastName}`, label: 'Name' },
        { name: (item) => JsxHelper.MailTo(item.Email), label: 'E-mail' },
        { name: 'PhoneNumber', label: 'Phone number' },
        { name: 'LastLoginDate', label: 'Last login' },
        { name: (item) => JsxHelper.YesNo(item.UserType === 'Agency'), label: 'Is Agency?', className: 'text-center' },
        {
          name: (item) => JsxHelper.YesNo(item.TimebasedSettlementEnabled),
          label: 'Time-based Settlement',
          className: 'text-center',
        },
        { name: (item) => JsxHelper.YesNo(item.IsEmployee), label: 'Is employee?' },
        { name: (item) => JsxHelper.YesNo(item.InvoiceNeeded), label: 'Invoice needed?' },
        { name: 'FirstName', label: 'First Name' },
        { name: 'LastName', label: 'Last Name' },
        { name: 'CreatedDate', label: 'Created' },
        { name: 'ModifiedDate', label: 'Modified' },
      ],
    },
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { name: 'CompanyName', label: 'Company name' },
        { name: 'CurrencyCode', label: 'Fee Currency' },
        { name: 'PaymentCurrencyCode', label: 'Payment Currency' },
        { name: 'PaymentMethod', label: 'Payment Method' },

        { name: 'PIAlipayAccount', label: 'Alipay Account' },
        { name: 'PIAccountHolderName', label: 'Account Holder Name' },
        { name: 'PIBankName', label: 'Bank Name' },
        { name: 'PIBranchNameOrId', label: 'Branch Name / Id' },
        { name: 'PIBankAddress', label: 'Bank Address' },
        { name: 'PIBankAccountNumber', label: 'Bank Account Number' },
        { name: 'PIBankAccountType', label: 'Bank Account Type' },
        { name: 'PISwiftIFSCCode', label: 'Swift/IFSC Code' },
        { name: 'PIIBANCodeBankAccountNumber', label: 'IBANCode/BankAccountNumber' },
        { name: 'PIPaypalWiseWesternUnionEmail', label: 'Paypal/Wise/WesternUnion Email' },
        { name: 'PIPIX', label: 'PIX' },
        { name: 'PICPFRUT', label: 'CPF/RUT' },
        { name: 'PIWesternUnionAddress', label: 'WesternUnionAddress' },
        { name: 'PIPIS', label: 'PIS' },
        { name: 'PIPayNow', label: 'Pay Now' },
        { name: 'EvaluatorName', label: 'Evaluator Name' },
        { name: (item) => JsxHelper.MailTo(item.EvaluatorEmail), label: 'Evaluator Email' },
        { name: 'PitpEvaluatorId', label: 'TpEvaluator ID' },
        { name: 'PIWiseTransferMethod', label: 'Wise Transfer Method' },
        { name: 'PIWiseTargetCurrencyCode', label: 'Wise Target Currency' },
        { name: 'PIBankCode', label: 'Bank Code' },
        { name: 'PIPanNo', label: 'Pan No.' },
        { name: 'Pimxclabe', label: 'MX CLABE' },

        { name: 'ContractorLocationCountryName', label: 'Contractor Location Country Name' },
        { name: 'ContractorLocationCountryId', label: 'Contractor Location Country Id' },
        {
          name: (item) =>
            item.PrimaryFreelancerUserId
              ? item.PrimaryFreelancerUserId +
                (item.PrimaryFreelancerUserName ? ` (${item.PrimaryFreelancerUserName})` : '')
              : '',
          label: 'His/Her agency',
        },
        { name: 'DqsupervisorUserName', label: 'DQ Supervisor' },
        { name: 'KamsuperVisorUserName', label: 'KAM Supervisor' },
        { name: 'RmsuperVisorUserName', label: 'RM Supervisor' },
        { name: 'OfficeName', label: 'Office' },
        { name: 'PaymentOfficeName', label: 'Payment Office' },
        { name: 'IsActive', label: 'Active' },
        { name: 'BareContactUserName', label: 'Bare Contact' },
        { name: 'PayIfSame', label: 'Pay If Self Schedule?' },
      ],
    },
    {
      tabName: 'IgnoredSurveys',
      tabLabel: 'Ignored Surveys',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: (item) => <FreelancerUserIgnoredSurveyAdmin freelancerUserId={item.FreelancerUserId} />,
          label: 'Ignored Surveys',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Roles',
      tabLabel: 'Roles',
      icon: 'fa-solid fa-hand-sparkles',
      data: [
        { name: 'IsFieldworkPartner', label: 'Fieldwork Partner', width: TabListTableCellWidthEnum.Double },
        { name: 'UserType', label: 'UserType' },
        { name: 'IsRM', label: 'RM', width: TabListTableCellWidthEnum.Double },
        { name: 'IsDQ', label: 'DQ', width: TabListTableCellWidthEnum.Double },
        { name: 'IsKAM', label: 'KAM', width: TabListTableCellWidthEnum.Double },
        { name: 'IsBD', label: 'BD', width: TabListTableCellWidthEnum.Double },
        { name: 'IsMarketing', label: 'Marketing', width: TabListTableCellWidthEnum.Double },
        { name: 'IsHR', label: 'HR', width: TabListTableCellWidthEnum.Double },
        { name: 'IsIT', label: 'IT', width: TabListTableCellWidthEnum.Double },
        { name: 'IsFinance', label: 'Finance', width: TabListTableCellWidthEnum.Double },
        { name: 'IsBI', label: 'BI', width: TabListTableCellWidthEnum.Double },
      ],
    },
    {
      tabName: 'Managers',
      tabLabel: 'Managers',
      icon: 'fa-solid fa-people-roof',
      data: [
        {
          name: (item) => <FreelancerUserManagerAdmin freelancerUser={item} />,
          label: 'Managers',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comment',
      data: [
        {
          name: FreelancerUserItem.getCommentsContent,
          label: 'Comments (related to the primary user)',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: FreelancerUserItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.TwoLines }],
    },
    {
      tabName: 'Attachments',
      tabLabel: 'Attachments',
      icon: 'fa-solid fa-paperclip',
      data: [
        {
          name: FreelancerUserItem.getAttachmentsContent,
          label: 'Attachments',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
  ];

  static getAttachmentsContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={10005}
        entityId={item.FreelancerUserId}
        enableAddNew={true}
      />
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show
  //   if type is FieldTypesEnum.FunctionField then it is the function
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Id',
        orderById: 'FreelancerUserId',
        data: 'FreelancerUserId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: '20px',
      },
      { label: 'Name', orderById: 'LastName', data: (item) => `${item.FirstName} ${item.LastName}` },
      { label: 'Email', orderById: 'Email', data: (item) => JsxHelper.MailTo(item.Email) },
      {
        label: 'Is Fieldwork Partner',
        orderById: 'IsFieldworkPartner',
        data: (item) => (item.IsFieldworkPartner ? JsxHelper.Yes() : null),
      },
      { label: 'User Type', orderById: 'UserType', data: (item) => FreelancerUserItem.UserTypeFieldContent(item) },
      {
        label: 'Contract Expires',
        orderById: 'ContractExpiryDate',
        data: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefiniteIcon(item.ContractExpiryDate),
      },
      { label: 'Roles', orderById: 'ApolloMgrId1', data: (item) => FreelancerUserItem.RoleContent(item) },
      // {label: "Items",orderById: "", data:FreelancerUserItem.getItemsCellContentItems,type: FieldTypesEnum.PureDataField},
      {
        label: 'Is Active?',
        orderById: 'IsActive',
        data: (item) => FreelancerUserItem.getIsActiveCellContent(item.IsActive),
      },
      {
        label: ' ',
        orderById: '',
        data: FreelancerUserItem.getActionsCellContentItems,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getIsActiveCellContent(item) {
    return (
      <div className='pointer'>
        {
          <FigmaBadge
            Active={item}
            ActiveText='Yes'
            InactiveText='No'
            width={50}
          />
        }
      </div>
    );
  }

  // static getItemsCellContentItems(item)
  // {
  //     return (
  // 		<>
  // 			<Link
  // 				linktext= {item.NumberOfFees}
  // 				withoutText={true}
  // 				title="Fees"
  // 				link={<FreelancerFeeAdmin
  // 						searchItem={new FreelancerFeeSearchParams(item.FreelancerUserId)}
  // 						showSearchPanel={false}
  // 					/>}
  // 				iconName="fa-solid fa-lightbulb-dollar"
  // 				tooltipText="Fees"
  // 			/>
  // 			{' '}
  // 			<Link
  // 				linktext={item.NumberOfLineItems}
  // 				withoutText={true}
  // 				title="Line Items"
  // 				link={<FreelancerLineItemAdmin
  // 						searchItem={new FreelancerLineItemSearchParams(item.FreelancerUserId)}
  // 						showSearchPanel={false}
  // 					/>}
  // 				iconName="fa-solid fa-paperclip"
  // 				tooltipText="Line Items"
  // 			/>
  // 			{' '}
  // 			<Link
  // 				linktext=""
  // 				withoutText={true}
  // 				title="Payable Assignments"
  // 				link={<FpaAdmin
  // 						freelancerUserId={item.FreelancerUserId}
  // 						showSearchPanel={false}
  // 					/>}
  // 				iconName="fa-solid fa-socks"
  // 				tooltipText="Payable Assignments"
  // 			/>
  // 			{' '}
  // 			<Link
  // 				linktext={item.NumberOfCreatedInvoices+"/"+item.NumberOfInvoices}
  // 				withoutText={true}
  // 				title="Vendor Invoices"
  // 				link={<FreelancerInvoiceAdmin
  // 						freelancerUserId={item.FreelancerUserId}
  // 						showSearchPanel={false}
  // 					/>}
  // 				iconName="fa-solid fa-file-invoice-dollar"
  // 				tooltipText="Invoices"
  // 			/>
  // 		</>
  // 	);
  // }

  static getActionsCellContentItems(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            title: 'Fees',
            link: (
              <FreelancerFeeAdmin
                searchItem={new FreelancerFeeSearchParams(item.FreelancerUserId)}
                showSearchPanel={false}
              />
            ),
            iconName: 'fa-solid fa-lightbulb-dollar',
            text: `Fees`,
            url: `freelancer_freelancerfees/search?FreelancerUserIdOrName=${item.FreelancerUserId}`,
          },
          {
            title: 'Line Items',
            link: (
              <FreelancerLineItemAdmin
                searchItem={new FreelancerLineItemSearchParams(item.FreelancerUserId)}
                showSearchPanel={false}
              />
            ),
            iconName: 'fa-solid fa-paperclip',
            text: `Line Items`,
            url: `freelancer_lineitems/search?FreelancerUserIdOrName=${item.FreelancerUserId}`,
          },
          {
            title: 'Payable Assignments',
            link: (
              <FpaAdmin
                freelancerUserId={item.FreelancerUserId}
                showSearchPanel={false}
              />
            ),
            iconName: 'fa-solid fa-socks',
            text: `Payable Assignments`,
            url: `freelancer_listassignments/search?FreelancerUserIdOrName=${item.FreelancerUserId}`,
          },
          {
            title: 'Vendor Invoices',
            link: (
              <FreelancerInvoiceAdmin
                freelancerUserId={item.FreelancerUserId}
                showSearchPanel={false}
              />
            ),
            iconName: 'fa-solid fa-file-invoice-dollar',
            text: `Vendor Invoices`,
            url: `freelancer_invoices/search?FreelancerUserIdOrName=${item.FreelancerUserId}`,
          },
          {
            separator: true,
          },
          {
            iconName: 'fa-solid fa-lightbulb-dollar',
            text: 'Add New Fee',
            disabled:
              !(
                item.IsDQ ||
                item.IsRM ||
                item.IsKAM ||
                (item.FreelancerRoleIds && item.FreelancerRoleIds.length > 0)
              ) || !item.IsActive,
            onClick: () => FreelancerUserItem.addNewFeeFunction(item.freelancerUserId, item),
            roleKey: 'freelancerdatatable_action',
          },
          {
            iconName: 'fa-solid fa-paperclip',
            text: 'Add New Line Item',
            disabled:
              !(
                item.IsDQ ||
                item.IsRM ||
                item.IsKAM ||
                item.IsFieldworkPartner ||
                (item.FreelancerRoleIds && item.FreelancerRoleIds.length > 0)
              ) || !item.IsActive,
            onClick: () => FreelancerUserItem.addNewLineItemFunction(item.freelancerUserId, item),
            roleKey: 'freelancerdatatable_action',
          },
          {
            iconName: 'fa-solid fa-search-dollar',
            text: 'Add invoice lines',
            disabled:
              !(
                item.IsDQ ||
                item.IsRM ||
                item.IsKAM ||
                item.IsFieldworkPartner ||
                (item.FreelancerRoleIds && item.FreelancerRoleIds.length > 0)
              ) || !item.IsActive,
            onClick: () => FreelancerUserItem.addNewInvoiceFunction(item.freelancerUserId, item),
            roleKey: 'freelancerdatatable_action',
          },
          {
            iconName: 'fa-brands fa-grav',
            text: 'Add Ignored Survey',
            disabled: !item.IsActive || (!item.IsDQ && !item.IsRM),
            onClick: () => FreelancerUserItem.addIgnoredSurveyFunction(item.freelancerUserId, item),
            roleKey: 'freelancerdatatable_action',
          },
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => FreelancerUserItem.editFunction(item.freelancerUserId, item),
            roleKey: 'FreelancerUser_EditAction',
          },
        ]}
      />
    );
  }

  static getEvaluatorSassieIdFieldContent(item) {
    return item.PIEvaluatorSassieId && item.OfficeId === 1 ? (
      <div
        onClick={() => FreelancerUserItem.clickOnPIEvaluatorSassieId(item)}
        className='link'
      >
        {item.PIEvaluatorSassieId}
      </div>
    ) : (
      item.PIEvaluatorSassieId
    );
  }

  static clickOnPIEvaluatorSassieId(item) {
    alert('click on piev');
  }

  static getTpEvaluatorIdFieldContent(item) {
    return item.PitpEvaluatorId && item.OfficeId === 1 ? (
      <div
        onClick={() => FreelancerUserItem.clickOnTpEvaluatorId(item)}
        className='link'
      >
        {item.PitpEvaluatorId}
      </div>
    ) : (
      item.PitpEvaluatorId
    );
  }

  static clickOnTpEvaluatorId(item) {
    alert('click on tp evaluator id');
  }

  static UserTypeFieldContent(item) {
    switch (item.UserType) {
      case FreelancerAgencyUserTypesEnum.IndependentUser:
        return 'Independent';
      case FreelancerAgencyUserTypesEnum.UserWithAgency:
        return 'User With Agency';
      default:
        return item.UserType;
    }
  }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='FreelancerUser'
        entityId={item.FreelancerUserId}
      />
    );
  }

  static getCommentsContent(item) {
    return (
      <Comments
        entityTypeId={10005}
        entityId={item.FreelancerUserId}
      />
    );
  }

  static RoleContent(item) {
    let res = '';
    res += item.IsRM ? 'RM' : '';
    res += item.IsDQ ? ' DQ' : '';
    res += item.IsKAM ? ' KAM' : '';
    res += item.UserType === FreelancerAgencyUserTypesEnum.Agency ? ' Ag' : '';
    res += item.IsFieldworkPartner ? 'Fieldwork Partner' : '';
    res += item.IsBD ? ' BD' : '';
    res += item.IsMarketing ? ' Marketing' : '';
    res += item.IsHR ? ' HR' : '';
    res += item.IsIT ? ' IT' : '';
    res += item.IsFinance ? ' Finance' : '';
    res += item.IsBI ? ' BI' : '';
    return res;
  }

  static editFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static addNewFeeFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static addNewLineItemFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static addNewInvoiceFunction = (id, user, userList) => {
    alert('Empty function');
    //this is a placeholder
  };

  static addIgnoredSurveyFunction = (id, user, userList) => {
    alert('Empty function');
    //this is a placeholder
  };

  static ConvertUserToJSON(user) {
    return {
      CompanyName: user.CompanyName,
      FirstName: user.FirstName,
      LastName: user.LastName,
      Email: user.Email,
      PhoneNumber: user.PhoneNumber,
      IsFieldworkPartner: booleanHelper.toBoolean(user.IsFieldworkPartner),
      UserType: user.UserType,
      PrimaryFreelancerUserId: parseInt(user.PrimaryFreelancerUserId),
      RMSuperVisorUserId: parseInt(user.RMSuperVisorUserId),
      DQSupervisorUserId: parseInt(user.DQSupervisorUserId),
      KAMSuperVisorUserId: parseInt(user.KAMSuperVisorUserId),
      OfficeId: parseInt(user.OfficeId),
      ApolloMgrId1: parseInt(user.ApolloMgrId1),
      ApolloMgrId2: parseInt(user.ApolloMgrId2),
      IsActive: booleanHelper.toBoolean(user.IsActive),
      CreatedDate: user.CreatedDate,
      ModifiedDate: user.ModifiedDate,
      ContractExpiryDate: user.ContractExpiryDate,
      IsKAM: booleanHelper.toBoolean(user.IsKAM),
      IsDQ: booleanHelper.toBoolean(user.IsDQ),
      IsRM: booleanHelper.toBoolean(user.IsRM),
      CurrencyId: parseInt(user.CurrencyId),
      PaymentMethod: user.PaymentMethod,
      PIAlipayAccount: user.PIAlipayAccount,
      PIAccountHolderName: user.PIAccountHolderName,
      PIBankName: user.PIBankName,
      PIBranchNameOrId: user.PIBranchNameOrId,
      PIBankAddress: user.PIBankAddress,
      PIBankAccountNumber: user.PIBankAccountNumber,
      PIBankAccountType: user.PIBankAccountType,
      PISwiftIFSCCode: user.PISwiftIFSCCode,
      PIIBANCodeBankAccountNumber: user.PIIBANCodeBankAccountNumber,
      PIPaypalWiseWesternUnionEmail: user.PIPaypalWiseWesternUnionEmail,
      PIPIX: user.PIPIX,
      PICPFRUT: user.PICPFRUT,
      PIWesternUnionAddress: user.PIWesternUnionAddress,
      PIPIS: user.PIPIS,
      PIPayNow: user.PIPayNow,
      PIEvaluatorSassieId: user.PIEvaluatorSassieId,
      TimebasedSettlementEnabled: booleanHelper.toBoolean(user.TimebasedSettlementEnabled),
      IsEmployee: booleanHelper.toBoolean(user.IsEmployee),
      InvoiceNeeded: booleanHelper.toBoolean(user.InvoiceNeeded),
      PIWiseTransferMethod: user.PIWiseTransferMethod,
      PIWiseTargetCurrencyId: parseInt(user.PIWiseTargetCurrencyId),
      PIBankCode: user.PIBankCode,
      ContractorLocationCountryId: user.ContractorLocationCountryId,
      PIBankNameAndCode: user.PIBankNameAndCode,
      PIPanNo: user.PIPanNo,
      BareContactUserId: user.BareContactUserId,
      FreelancerRoleIds: user.FreelancerRoleIds,
      PaymentCurrencyId: user.PaymentCurrencyId,
      PaymentOfficeId: user.PaymentOfficeId,
    };
  }

  static CorrectingTheTypes(user) {
    user.IsFieldworkPartner = booleanHelper.toBoolean(user.IsFieldworkPartner);
    if (user.isFieldworkPartner) {
      if (user.UserType === FreelancerAgencyUserTypesEnum.Agency) {
        user.UserType = FreelancerAgencyUserTypesEnum.IndependentUser;
      }
      user.PrimaryFreelancerUserId = null;
    } else if (user.UserType === FreelancerAgencyUserTypesEnum.UserWithAgency) {
      user.PrimaryFreelancerUserId =
        parseInt(user.PrimaryFreelancerUserId) > 0 ? parseInt(user.PrimaryFreelancerUserId) : null;
    } else {
      user.PrimaryFreelancerUserId = null;
    }
    user.PrimaryFreelancerUserId =
      parseInt(user.PrimaryFreelancerUserId) > 0 ? parseInt(user.PrimaryFreelancerUserId) : null;
    user.OfficeId = parseInt(user.OfficeId) > 0 ? parseInt(user.OfficeId) : 1;
    user.PaymentOfficeId = parseInt(user.PaymentOfficeId) > 0 ? parseInt(user.PaymentOfficeId) : null;
    user.CurrencyId = parseInt(user.CurrencyId) > 0 ? parseInt(user.CurrencyId) : null;
    user.PaymentCurrencyId = parseInt(user.PaymentCurrencyId) > 0 ? parseInt(user.PaymentCurrencyId) : 1;
    user.IsKAM = booleanHelper.toBoolean(user.IsKAM);
    user.IsDQ = booleanHelper.toBoolean(user.IsDQ);
    user.IsRM = booleanHelper.toBoolean(user.IsRM);
    user.IsActive = booleanHelper.toBoolean(user.IsActive);
    user.TimebasedSettlementEnabled = booleanHelper.toBoolean(user.TimebasedSettlementEnabled);
    user.IsEmployee = booleanHelper.toBoolean(user.IsEmployee);
    user.InvoiceNeeded = booleanHelper.toBoolean(user.InvoiceNeeded);
    user.ApolloMgrId1 = parseInt(user.ApolloMgrId1) > 0 ? parseInt(user.ApolloMgrId1) : null;
    user.ApolloMgrId2 = parseInt(user.ApolloMgrId2) > 0 ? parseInt(user.ApolloMgrId2) : null;
    user.PIEvaluatorSassieId = parseInt(user.PIEvaluatorSassieId) > 0 ? parseInt(user.PIEvaluatorSassieId) : null;
    user.PitpEvaluatorId = parseInt(user.PitpEvaluatorId) > 0 ? parseInt(user.PitpEvaluatorId) : null;
    user.PIWiseTargetCurrencyId =
      parseInt(user.PIWiseTargetCurrencyId) > 0 ? parseInt(user.PIWiseTargetCurrencyId) : null;
    user.ContractorLocationCountryId =
      parseInt(user.ContractorLocationCountryId) > 0 ? parseInt(user.ContractorLocationCountryId) : null;

    return user;
  }
}
